import { createSlice } from '@reduxjs/toolkit';
import { getClinicReports } from './clinicReportsThunk';

const clinicReportsSlice = createSlice({
  name: 'clinicReports',
  initialState: { data: [], total: 0, loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getClinicReports.pending, (state) => { state.loading = true; })
      .addCase(getClinicReports.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data; // NestJS renvoie { data: [], total: X }
        state.total = action.payload.total;
      })
      .addCase(getClinicReports.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default clinicReportsSlice.reducer;